module.exports = __webpack_public_path__ + "img/signup-dark.2c02039d.svg";